export const snakeToTitle = (str: string) => {
  return str.split('_')
    .map(word =>
        word.toLowerCase() === 'id' ?
        'ID' : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
